import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUserData from "../hooks/useUserData";
import MUIDataTable from "mui-datatables";
import StatusModule from "./StatusModule";



const resourceCategories = {
  "white": ["Metals", "Baobabs", "Silicon", "Space Oats", "Nuclear Waste"],
  "#40BF00": ["Petroleum", "Vis", "Jelly Beans", "Copper", "Tin", "Silver", "Titanium", "Psion Icicles"],
  "#007FFC": ["Diamond", "Quantumum", "Alien Bacteria", "Enriched Nuclear Material", "Laconia", "Plasma Crystals", "Gold"],
  "#D86D00": ["Energon", "Dark Matter", "Frozen Blob", "Adamantium", "Rubicite", "Platinum", "Ablution Crystals", "Bacta", "Fermium", "Atmospheric Disturbances", "Dunes", "Roosts", "Trobbles", "Astral Worms"],
  "#992cff": ["Thickened Atmosphere", "Stabilized Weather", "Breathtaking Vistas", "Magnetic Miracle", "Biogeneticists Playground"],
  "#FE2712": ["Goop"]
};

const viewStatus = localStorage.getItem("userStatus");

if (viewStatus)
{
  console.log("View status returned as" + viewStatus);
}
else
{
  console.log("No view status variable found");
}

const getResourceColor = (resourceName) => {
  if (!resourceName) return "white";
  const normalizedName = resourceName.trim().toLowerCase();
  for (const [color, resources] of Object.entries(resourceCategories)) {
    if (resources.some(res => res.toLowerCase() === normalizedName)) {
      return color;
    }
  }
  return "white";
};

const TeamScans = () => {
  const navigate = useNavigate();
  const { userData, loading } = useUserData();
  const [scans, setScans] = useState([]);
  const [rows, setRows] = useState([]);
  const [includeTeamScans, setIncludeTeamScans] = useState(true);
  const [ownersMapping, setOwnersMapping] = useState({});
  const [teamsMapping, setTeamsMapping] = useState({});

    useEffect(() => {
        if (!loading) {
            if (!userData) {
                navigate("/starsonata"); 
            } else if (userData.teamId === "unassigned") {
                navigate("/join");
            } else if (!userData.verified) {
                navigate("/pending");
            }
        }
    }, [userData, loading, navigate]);

  // fetch scan data
  useEffect(() => {
    if (!loading && userData?.verified) {
      fetch("https://imp.slypandainteractive.com/galaxies")
        .then((res) => res.json())
        .then(setScans)
        .catch((err) => console.error("Error loading scans:", err));
    }
  }, [userData, loading]);

  // fetch ownership data
  useEffect(() => {
    fetch("/universe.json")
      .then((res) => res.json())
      .then((data) => {
        const mapping = {};
        if (data.galaxies) {
          Object.values(data.galaxies).forEach((g) => {
            if (g.name && g.owningTeamID) {
              mapping[g.name.trim().toLowerCase()] = g.owningTeamID;
            }
          });
        }
        setOwnersMapping(mapping);
      })
      .catch((err) => console.error("Error loading universe.json:", err));
  }, []);

  // fetch teams data
  useEffect(() => {
    fetch("/teams.json")
      .then((res) => res.json())
      .then((data) => {
        const mapping = {};
        if (data.teams) {
          Object.values(data.teams).forEach((team) => {
            if (team.teamID && team.name) {
              mapping[team.teamID] = team.name;
            }
          });
        }
        setTeamsMapping(mapping);
      })
      .catch((err) => console.error("Error loading teams.json:", err));
  }, []);

  // group scans
  useEffect(() => {
    const grouped = {};

    scans
      // .filter(scan => {
      //   const team = String(scan.upload_team ?? "0");
      //   const myTeam = String(userData?.teamId ?? "");
      //   return team === myTeam || (includeTeamScans && team === "1932");
      // })
      .forEach(scan => {
        if (!scan.galaxy) return;

        const galaxy = scan.galaxy.trim();
        const resource = scan.resource_name ? scan.resource_name.trim() : null;
        const color = getResourceColor(resource);
        const total = scan.total_amount;
        const team = String(scan.upload_team ?? "0");

        if (!grouped[galaxy]) grouped[galaxy] = [];

        if (resource) {
          grouped[galaxy].push({
            resource,
            total,
            color,
            upload_team: team
          });
        }
      });



    const tableRows = Object.entries(grouped)
      .map(([galaxy, resources]) => {
        const lowerGalaxy = galaxy.toLowerCase();
        const owningTeamId = ownersMapping[lowerGalaxy];
        const resourceStr =
          resources.length === 0
            ? "<span style=\"opacity:0.7\">No resources</span>"
            : resources
                .map((r) => `<span style="color:${r.color}">${r.resource}: ${r.total}</span>`)
                .join(", ");
        return [owningTeamId, galaxy, resourceStr];
      })
      .sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: "base" }));

    setRows(tableRows);
  }, [scans, includeTeamScans, userData, ownersMapping]);

  const columns = [
    {
      name: "Owner",
      options: {
        sort: false,
        filter: false,
        setCellHeaderProps: () => ({ style: { textAlign: "center", whiteSpace: "nowrap" } }),
        setCellProps: () => ({ style: { textAlign: "center", whiteSpace: "nowrap" } }),
        customBodyRender: (teamId) =>
          teamId && teamId !== "0" ? (
            <img
              src={`https://www.starsonata.com/images/team_flags/game/${teamId}`}
              alt={`Team ${teamId}`}
              title={teamsMapping[teamId] || `Team ${teamId}`}
              style={{ maxWidth: "40px", maxHeight: "40px" }}
            />
          ) : (
            "—"
          ),
      },
    },
    {
      name: "Galaxy",
      options: {
        setCellHeaderProps: () => ({ style: { textAlign: "center", whiteSpace: "nowrap" } }),
        setCellProps: () => ({ style: { textAlign: "center", whiteSpace: "nowrap" } })
      }
    },
    {
      name: "Resources",
      options: {
        setCellHeaderProps: () => ({ style: { textAlign: "center", whiteSpace: "nowrap" } }),
        customBodyRender: (value) => (
          <span dangerouslySetInnerHTML={{ __html: value }} />
        ),
      },
    },
  ];


  const options = {
    selectableRows: "none",
    elevation: 0,
    responsive: "standard",
    rowsPerPage: 100,
    onRowClick: (rowData) => {
      const galaxy = rowData[1];
      navigate(`/scandetails/${encodeURIComponent(galaxy)}`);
    },
    componentsProps: {
      tableHeadCell: {
        className: "custom-table-header"
      }
    },
    setRowProps: () => ({
      className: "custom-table-cell"
    }),
    setTableProps: () => ({
      className: "custom-table-root"
    }),
    textLabels: {
      body: {
        noMatch: "No scans found."
      }
    }
  };



  return (
    <div style={{ padding: "0 1rem" }}>
      <div
        style={{
          border: "1px solid #444",
          borderRadius: "10px",
          padding: "1.5rem",
          backgroundColor: "#1e1e1e",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          width: "100%",
          maxWidth: "1320px",
          margin: "0 auto",
          boxSizing: "border-box"
        }}
      >
      <h3 style={{ textAlign: "center", margin: "0 0 0.75rem" }}>
        Galaxy Scans
      </h3>
      <div
        style={{
          padding: "1rem 1.5rem 1.5rem",
          borderRadius: "6px",
          backgroundColor: "#1e1e1e",
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem"
        }}
      >
        {false && <StatusModule compact />}

        {false && (
          <div className="scans-table-wrap">
            <MUIDataTable
              title={null}
              data={rows}
              columns={columns}
              options={{
                ...options,
                setRowProps: () => ({
                  className: "custom-table-cell"
                }),
                setTableProps: () => ({
                  className: "custom-table-root"
                })
              }}
            />
          </div>
        )}
        <div className="team-scan-table">
          <div className="team-scan-table__header">
            <div className="team-scan-table__cell team-scan-table__cell--owner">Owner</div>
            <div className="team-scan-table__cell">Galaxy</div>
            <div className="team-scan-table__cell">Resources</div>
          </div>
          {rows.length === 0 ? (
            <div className="team-scan-table__empty">No scans found.</div>
          ) : (
            rows.map(([owningTeamId, galaxy, resourceStr]) => {
              const teamName =
                owningTeamId && teamsMapping[owningTeamId]
                  ? teamsMapping[owningTeamId]
                  : `Team ${owningTeamId}`;
              return (
                <div
                  key={galaxy}
                  className="team-scan-table__row"
                  onClick={() => navigate(`/scandetails/${encodeURIComponent(galaxy)}`)}
                >
                  <div className="team-scan-table__cell team-scan-table__cell--owner">
                    {owningTeamId && owningTeamId !== "0" ? (
                      <img
                        src={`https://www.starsonata.com/images/team_flags/game/${owningTeamId}`}
                        alt={teamName}
                        title={teamName}
                        style={{ maxWidth: "40px", maxHeight: "40px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                  <div className="team-scan-table__cell">{galaxy}</div>
                  <div
                    className="team-scan-table__cell team-scan-table__cell--resources"
                    dangerouslySetInnerHTML={{ __html: resourceStr }}
                  />
                </div>
              );
            })
          )}
        </div>
      </div>
      </div>
    </div>
  );
};

export default TeamScans;



